<template>
  <b-modal
    id="delete-license-modal"
    no-close-on-backdrop
    title="Delete License"
  >
    Are you sure you want to delete license
    <template #modal-footer="{cancel}">
      <div>
        <b-button
          variant="danger"
          class="mr-1"
          :disabled="submitting"
          @click="cancel"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="submitting"
          @click="submit"
        >
          <b-spinner
            v-if="submitting"
            small
          />
          <span v-else>Confirm</span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import { BModal, BButton, BSpinner } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BModal,
    BSpinner,
    BButton,
  },
  props: {
    license: {
      type: Function,
      required: true,
    },
    dlicenses: {
      type: Array,
      required: true,
    },
  },
  setup(props, ctx) {
    const submitting = ref(false)
    const submit = async () => {
      try {
        submitting.value = true
        await props.license(props.dlicenses)
        ctx.root.$bvModal.hide('delete-license-modal')
      } catch (err) {
        console.log(err)
        errorNotification('Something went wrong')
      } finally {
        submitting.value = false
      }
    }
    return { submit, submitting }
  },
}
</script>
